import application from 'application/application';

import $ from 'jquery';

const controller = 'ForgotPasswordController';

/* eslint-disable no-unused-vars */

application

	.controller(controller, ['$scope', '$http', '$state', 'helper', 'API', '$rootScope', ($scope, $http, $state, helper, API, $rootScope) => {
		$scope.renderDate = new Date;

		let logoPartner = localStorage.getItem('__authenticationLogo__');

		if (logoPartner != null)
			$rootScope.logoPartner = {
				avatar: `data:image/png;charset=utf-8;base64, ${logoPartner}`
			};

		$scope.showFeedback = false;

		const idParceiro = localStorage.getItem('__authenticationIdParceiro__');

		$scope.resetPassword = email => {

			$('.busy-overlay').addClass('open');

			$http({
				...helper.http(API.forgotPassword, 'POST'),
				data: {
					idParceiro: idParceiro,
					email: email
				},
				status
			})

				/** @TODO: Alterar o redirecionamento quando solicionar o problema com `stateService.prototype.go`. */
				.then(() => $scope.showFeedback = true)

				.finally(() => {
					$('.busy-overlay').removeClass('open');

					$state.go('root.login', {}, { inherit: false });

				});

		};

		$scope.goTo = routePath => location.href = $state.get(routePath).url || '/';

	}]);

export default controller;
